<form #myForm="ngForm">
    <!-- <fieldset ngModelGroup="params" #params="ngModelGroup">
      <div class="row no-gutters">
        <form-parameters
          #parameters
          [context]= "this"
          [formParameterList]="_params"
          class="col-12"
        ></form-parameters>
      </div>
    </fieldset>

    <div *ngIf="_exceptionMessage" class="row exception-message-report">
        <div class="alert alert-danger">{{ _exceptionMessage }}</div>
    </div> -->

    <!-- Botonera de acciones y navegación -->
    <div class="row no-gutters mt-2 mb-3">
      <div class="col-sm-2 col-xs-12 d-flex align-items-center">
        <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        id="reports-btn-execute"
        (click)="execReport(myForm, null)"
        [disabled]="_mustExecuteReport"
        [tooltip]="_appService.CoreCommonLiterals.ReportExecute"
        ><i class="fa-solid fa-play"></i>
        </button>
        <button
        type="button"
        class="btn btn-primary mr-2"
        id="reports-btn-execute"
        (click)="expand()"
        [tooltip]="'Mas opciones'"
        ><i class="fa-solid fa-arrow-down"></i>
        </button>
        <button
        *ngIf="enableCleanButton"
        id="clear-btn"
        type="button"
        class="btn btn-primary mr-2"
        [tooltip]="_appService.CoreCommonLiterals.Clear"
        (click)="cleanAllData()"
        ><i class="fa-solid fa-trash-can"></i>
        </button>
        <button
        id="reset-btn"
        type="button"

        class="btn btn-primary mr-2"
        (click)="resetParams()"
        [tooltip]="_appService.CoreCommonLiterals.ButtonReset"
        ><i class="fa-solid fa-arrow-rotate-left"></i>
        </button> -->
        <download 
        *ngIf="enableExportButton"
        #download
        (downloadClick)="execReport(myForm, $event)"
        [exportFormats]="_exportFormats"
        ></download>
        <button id="filter-btn-custom1" *ngIf="customButton1Text" [tooltip]="customButton1Tooltip" [disabled]="customButton1Disabled" (click)="onCustomButtonClick($event, 'onCustomButton1')" class="btn btn-primary mr-2 filter-btn-custom">{{customButton1Text}}</button>
        <button id="filter-btn-custom2" *ngIf="customButton2Text" [tooltip]="customButton2Tooltip" [disabled]="customButton2Disabled" (click)="onCustomButtonClick($event, 'onCustomButton2')" class="btn btn-primary mr-2 filter-btn-custom ">{{customButton2Text}}</button>
        <button id="filter-btn-custom3" *ngIf="customButton3Text" [tooltip]="customButton3Tooltip" [disabled]="customButton3Disabled" (click)="onCustomButtonClick($event, 'onCustomButton3')" class="btn btn-secondary mr-2 align-self-end ml-auto filter-btn-custom">{{customButton3Text}}</button>
        <button id="filter-btn-custom4" *ngIf="customButton4Text" [tooltip]="customButton4Tooltip" [disabled]="customButton4Disabled" (click)="onCustomButtonClick($event, 'onCustomButton4')" class="btn btn-secondary mr-2 align-self-end filter-btn-custom" [ngClass]="{'ml-auto': !customButton3Text}">{{customButton4Text}}</button>
        <div class="position-relative d-inline-block text-right" dropdown *ngIf="customButton5Text && enabledDropdownButton" [isDisabled]="customButton5Disabled">
          <button id="btn-filter-list" class="btn btn-primary filter-btn-custom" [tooltip]="customButton5Tooltip" dropdownToggle type="button" [disabled]="customButton5Disabled">{{customButton5Text}} <i class="ml-2 fa-solid fa-caret-down"></i></button>
          <ul *dropdownMenu class="dropdown-menu dropdown-menu-left dropdown-menu-lg-right" role="menu">
            <li role="menuitem" [id]="'filter-menu-list-'+i" *ngFor="let item of menuButtonList; let i = index;" (click)="item?.disabled ? onDisabledClick($event) : null">
              <a type="button" class="dropdown-item" [id]="item.value" href="#" (click)="menuButtonSelect = item; action($event); " [ngClass]="{'disabled': item?.disabled}">
                <i [attr.class]="'mr-2 fa-solid ' + item?.icon"></i>{{item.label}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
</form>